import React from 'react';

import caret from './images/caret.svg';
import minus from './images/minus.png';
import plus from './images/plus.png';

export const ProductPurchase = ({ price }) =>
  <section className='product__purchase' >
    <div className='row flex-space-between spacer-bottom-md'>
      <div className='product__purchase__options'>
        <h4>
          Quantity <a aria-label='Decrease Quantity' href='' className='image-link'><img src={minus} alt="Decrease Quantity" /></a> 1
          <a aria-label='Increase Quantity' href='' className='image-link'><img src={plus} alt="Increase Quantity" /></a>
        </h4>
        <a aria-label='One time purchase' href='' className='mock-select'>
          <h4>One time purchase<img src={caret} alt="Select Frequency" /></h4>
        </a>
      </div>
    </div>
    <div className='row flex-space-between'>
      <h2 className='product__purchase__price'>{price}</h2>
      <button aria-label='Add To Bag' className='product__purchase__add-button' name="AddToBag">Add to Bag</button>
    </div>
  </section>
